var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 14.6666C11.3131 14.6666 14.6666 12 14.6666 7.99998C14.6666 3.99998 11.3131 1.33331 7.99992 1.33331C4.68672 1.33331 1.33325 3.99998 1.33325 7.99998C1.33325 12 4.68672 14.6666 7.99992 14.6666ZM11.4515 6.62424C11.6858 6.38993 11.6858 6.01003 11.4515 5.77572C11.2171 5.5414 10.8372 5.5414 10.6029 5.77572L7.12719 9.25145L5.42418 7.54844C5.18987 7.31413 4.80997 7.31413 4.57565 7.54844C4.34134 7.78276 4.34134 8.16266 4.57565 8.39697L6.70293 10.5242C6.93724 10.7586 7.31714 10.7586 7.55146 10.5242L11.4515 6.62424Z",
    fill: "#008E53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon_success.a1a1d2fd53a3a7898c33868b41bdc95f.svg";
export { ForwardRef as ReactComponent };